module.exports = __webpack_public_path__ + "img/step7.34434c95.png";